// Extensions
import {
  ErrorHandler,
  Injector,
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from '@core/core.module';
import { AppInjector } from '@core/service';
import { FeatureModule } from '@feature/feature.module';
import { MainComponent } from '@feature/main/main.component';
import {
  LibComponentsModule,
  LibPipeModule,
  UtcDateWithoutTimeZonePipe,
  UtcToLocalPipe,
} from '@mynexus/mynexus-ui-lib';
import { HomeModule } from '@pages/home/home.module';
import { ElementRegistryService } from '@shared/services/element-registry.service';
import { SharedModule } from '@shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import './shared/extension/string.extension';
import { AuthorizationRequestComponent } from '@products/dmepos/pages/authorization-request/authorization-request.component';
import { ProviderDashboardComponent as DmeposProviderDashboardComponent } from '@products/dmepos/pages/provider-dashboard/provider-dashboard.component';
import { ProviderDashboardComponent as PacProviderDashboardComponent } from '@products/pacim/pages/provider-dashboard/provider-dashboard.component';
import { SidebarModule } from '@shared/component/ng-sidebar';
import { MsalRedirectComponent } from '@azure/msal-angular';
import { NotificationsComponent } from '@feature/notifications/notifications.component';
import { ApplicationinsightsAngularpluginErrorService } from '@microsoft/applicationinsights-angularplugin-js';
import { providePrimeNG } from 'primeng/config';
import { Carelon, CSS_LAYERS_ORDER } from '@mynexus/theme';

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    AuthorizationRequestComponent,
    DmeposProviderDashboardComponent,
    PacProviderDashboardComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    SharedModule,
    FeatureModule,
    HomeModule,
    LibPipeModule,
    LibComponentsModule,
    SidebarModule.forRoot(),
    NotificationsComponent,
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
  providers: [
    providePrimeNG({
      ripple: false,
      theme: {
        preset: Carelon,
        options: {
          darkModeSelector: false,
          cssLayer: {
            name: 'primeng',
            order: CSS_LAYERS_ORDER
          }
        },
      }
    }),
    {
      provide: ErrorHandler,
      useClass: ApplicationinsightsAngularpluginErrorService
    },
    UtcToLocalPipe,
    ElementRegistryService,
    UtcDateWithoutTimeZonePipe,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {
  constructor(injector: Injector) {
    AppInjector.setInjector(injector);
  }
}
